import styled from 'styled-components';

import type { CleaningPrestation } from '@wecasa/common/src/types/commons';

import { translate } from '@wecasa/i18n';

import Text from '@wecasa/web-ui/src/components/base-text/variants/text';
import TextButton from '@wecasa/web-ui/src/components/button/text-button';

const t = translate('basket.membership.card');

const BlockTitle = styled(Text.SMBold)`
  display: block;
`;

type NotMemberWithRecurringPrestationProps = {
  getMoreInfoPress: () => void;
  cleaningPrestation?: CleaningPrestation;
};

const NotMemberWithRecurringPrestation = ({
  getMoreInfoPress,
  cleaningPrestation,
}: NotMemberWithRecurringPrestationProps) => {
  const cleaningPrestationTitle = cleaningPrestation?.title.toLowerCase() || '';

  return (
    <span>
      <BlockTitle>{t('.cleaning.recurring.text_1')}</BlockTitle>
      <Text.SM>{`${t('.cleaning.recurring.text_2', { prestation: cleaningPrestationTitle })} `}</Text.SM>
      <TextButton size='sm' onClick={getMoreInfoPress}>
        {t('.more_info_link')}
      </TextButton>
    </span>
  );
};

export default NotMemberWithRecurringPrestation;
